import {MuWidget} from "mu-widget/lib/MuWidget";
import {MuBinder} from "mu-widget/lib/MuBinder";
import {MuLabelFor} from "mu-widget/lib/MuLabelFor";
import {MuKeyBind} from "mu-widget/lib/MuKeyBind";
import {MuInspector} from "./ts/MuInspector";
import {setupFilters} from "./ts/BindFilters";
import * as uiTabsrequire from 'mu-widget/lib/UiTabs';
import {registerWidgets} from "./ts/generated/widgetLoader";
import {IMuWidget} from "./ts/IMuWidget";

/* MuWidget.registerAll(
	require("./UiScripting"),
	require("./Htmlarea"),
	require("./UiFlashMessage"),
	require("./UiSelector"),
	require("./TicketTree"),
	require("./InvoiceApproval"),
	require("./UiFlashMessage"),
	require("./AccountSelector"),
	require("./SearchSelector"),
	require("./ApprovingSchemaEditor"),
	require("./TicketTree"),
	require("./AccountRoles"),
	require("./ShareButton"),
	require("./TPFAttaches"),
	require("./TreeSelector"),
	require("./MultiUpload"),
	require("./TicketFormField"),
	require("./WorklogSimple"),
	require("./ShowMore"),
	require("./AccountRolesField"),
	require("./BulkStateChange"),
	require("./AccountRolesField"),
	require("./UiBilling"),
	require("./UiSavedFilters"),
	require("./UiSavedFiltersAdmin"),
	require("./UiNotify"),
	require("./UrlInput"),
	require("./ShowMore"),
	require("./Course"),
	require("./CourseEditor"),
	require("./SearchSelector"),
	require("./UiSelect"),
	require("./CronRuleItems"),
	require('./CalendarPage'),
	require("./UiCalendarItemDetail"),
	require("./TopPage"),
	require("./TodoTicketForm"),
	require("./AttachList"),

	require("./components/UiTable"),
	require("./components/UiTomSelect"),
	require("./components/UiBuSubjectSelector"),
	require("./components/UiOrgProjectSelector"),
	require("./components/UiAccountSelector"),
	require("./components/UiDateFilter"),
	require("./components/UiRadioList"),
	require("./components/UiPager"),
	require('./components/UiTree'),
	require('./components/UiInlineTreeSelector'),
	require('./components/UiDateTimeRange'),
	require('./components/UiNumberRange'),
	require('./components/Pager'),
	require('./components/AccountLink'),
	require('./components/TreeView'),
	require('./components/UiChboxList'),
	require('./components/BaseCompanyForm'),
	require('./components/RelatedAccountSelector'),
	require('./UiCharCounter'),
	require('./components/DateRepeating'),
	require('./components/CalendarOverview'),

	require("./dms/UiDms"),
	require("./dms/UiBuSubjectEditor"),
	require("./dms/UiDmsDocumentEditor"),
	require("./dms/UiBuSubjects"),
	require("./dms/UiDmsDocuments"),
	require("./dms/UiDocumentListPreview"),
	require('./dms/UiDmsAttaches'),
	require('./dms/UiDmsHistory'),
	require('./dms/UiDmsOrgProjects'),
	require('./dms/UiNewDocumentAttach'),

	require('./pqm/ProcDataField'),

	require('./UiProjectImport'),
	require('./todo/UiTodoButton'),
	require('./UiComments'),

	require('./UiModalContainer'),
	require('./ticketOverview/BaseTO'),

	require('./ticketOverview/TOInvoiceApproving'),
	require('./ticketOverview/TOIInvoiceApproving'),
	require('./ticketOverview/InvoiceApprovingFilter'),

	require('./ticketOverview/TOPqm'),
	require('./ticketOverview/pqm/UiPqmLauncher'),

	require('./pqm/PqmTicketList'),
	require('./pqm/PqmTicketDetail'),
	require('./pqm/PqmField'),
	require('./pqm/PqmPackets'),

	require('./pqm/Fields/PqmFieldText'),
	require('./pqm/Fields/PqmFieldDate'),
	require('./pqm/Fields/PqmFieldBool'),
	require('./pqm/Fields/PqmFieldEnum'),
	require('./pqm/Fields/PqmFieldSet'),
	require('./pqm/Fields/PqmFieldCompany'),
	require('./pqm/Fields/PqmFieldAccount'),
	require('./pqm/Fields/PqmFieldOrgDivision'),
	require('./pqm/Fields/PqmFieldAttach'),

	require('./ticketOverview/TOIPqm'),

	require('./components/TicketAccountSelector'),

	require('./TicketTypeFormField'),
	require('./TicketRelField'),

	require('./UiTicketFieldAttaches'),
	require('./InvoiceCreator'),
	require('./UiTicketRels'),
	require('./UiSplitByAttach'),
	require('./UiAttaches'),
	require('./UiProductImport'),

	require('./Attaches2'),
	require('mu-widget/lib/UiTabs'),

	require('./Sandbox'),

	require('./ticketOverview/pqm/UiPqmFilter'),
	require('./WorklogEditor'),
); */
registerWidgets();

MuLabelFor.register(MuWidget, true);
setupFilters();
// @ts-ignore
MuWidget.registerAs(IMuWidget, ".")

MuBinder.register(MuWidget);
MuWidget.fixOldWidgets = "silent";
MuKeyBind.register(MuWidget);
MuInspector.register();
MuWidget.startup(undefined, function(muRoot) {
	// @ts-ignore
	window.rootMuWidget = muRoot;
});
